import React from 'react';
import { StyledStatusChip } from './styles';
import { StatusChipProps } from './types';
import { chipStatus } from './constants';

export const StatusChip = ({ status }: StatusChipProps) => {
  return (
    <StyledStatusChip
      label={chipStatus[status]}
      status={status}
      data-testid={`${chipStatus[status].toLowerCase()}-chip`}
    />
  );
};
